<ng-template #labelContent
  ><div
    [ngClass]="showSmallLabel ? 'small-label' : 'label'"
    [id]="fieldLabelId"
  >
    {{ label }}
  </div></ng-template
>

<ng-template #subText><ng-content></ng-content></ng-template>

@if (isEditMode) {
  @if (editForm.controls.description) {
    <form class="grow" [formGroup]="editForm">
      <ng-template [ngTemplateOutlet]="labelContent"></ng-template>
      <mat-form-field appearance="outline">
        <input
          #description
          matInput
          forbidAngleBrackets
          type="text"
          formControlName="description"
          [attr.aria-laabelledby]="fieldLabelId"
        />
        @if (editForm.controls.description.hasError('unique')) {
          <mat-error>
            {{ editForm.controls.description.getError('unique') }}
          </mat-error>
        }
        @if (editForm.controls.description.hasError('required')) {
          <mat-error> {{ label }} is required. </mat-error>
        }
        @if (editForm.controls.description.hasError('email')) {
          <mat-error> {{ label }} has to be a valid email. </mat-error>
        }
        @if (editForm.controls.description.hasError('urlPattern')) {
          <mat-error> {{ label }} has to be a valid url. </mat-error>
        }
        @for (
          error of editForm.controls.description.errors | keyvalue;
          track error
        ) {
          <mat-error>
            @if (
              !['unique', 'required', 'email', 'urlPattern'].includes(error.key)
            ) {
              {{ error.value }}
            }
          </mat-error>
        }
      </mat-form-field>
    </form>
  }
  <button mat-flat-button color="primary" (click)="onSaveClicked()">
    <mat-icon>check</mat-icon> Save
  </button>
  <button type="button" mat-stroked-button (click)="cancelEditMode()">
    <mat-icon>close</mat-icon> Cancel
  </button>
} @else if (readOnly) {
  <div class="grow">
    <ng-template [ngTemplateOutlet]="labelContent"></ng-template>
    <div class="description-value">
      {{ description }}
    </div>
    <ng-template [ngTemplateOutlet]="subText"></ng-template>
  </div>
} @else {
  <div
    class="grow"
    [ngClass]="{ hovering: clickToEdit }"
    (click)="clickToEdit && enterEditMode()"
  >
    <ng-template [ngTemplateOutlet]="labelContent"></ng-template>
    <div class="description-value">
      {{ description }}
      @if (!description && clickToEdit) {
        <span class="add">Click to add</span>
      }
    </div>
    <ng-template [ngTemplateOutlet]="subText"></ng-template>
  </div>

  @if (!clickToEdit) {
    <button mat-stroked-button (click)="enterEditMode()" aria-label="Edit">
      <mat-icon>edit</mat-icon> Edit
    </button>
  } @else if (description) {
    <button
      mat-icon-button
      color="primary"
      (click)="onDeleteClicked()"
      aria-label="Delete"
    >
      <mat-icon>delete</mat-icon>
    </button>
  }
}
